import React from "react";

// Style //
import "./TimeSheetTable.css";

// Components //
import Table from "react-bootstrap/Table";
import { TableRowLoader } from "../../components/index";
import {
  dateFormateFullMonth,
  dateFormate,
} from "../../../constents";

// Images //
import { icons } from "../../../assets/index";

// Hooks //
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const TimeSheetTable = ({ timeSheetData, siteName }) => {
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.utils);

  const timeSheetOtherStatus = {
    COMPLETED: "COMPLETED",
    TO_BE_COMPLETED: "TO BE COMPLETED",
  };

  return (
    <>
      {loading ? (
        <TableRowLoader limit={8} />
      ) : (
        <>
          <Table className="common-table" bordered>
            <thead>
              <tr>
                <th></th>
                <th>Pay Date</th>
                <th>Timesheet Period</th>
                <th>No. of Sub-Contractor</th>
                <th>Avg Weekly Pay</th>
                <th>Gross Pay</th>
                <th>Status</th>
                <th>View Timesheet</th>
              </tr>
            </thead>
            <tbody>
              {!timeSheetData?.length ? <td colSpan={8} style={{ fontSize: '1rem', textAlign:'center' }}>No Timesheets Found</td> : timeSheetData?.map((item, index) => {
                const allTimesheets = !siteName ? ((item.TimeSheets || item.ManualTimeSheets) ? [...item.TimeSheets, ...item.ManualTimeSheets] : []) : [item];
                const is_freezed = allTimesheets?.some(ts => ts.is_freezed);                
                const getTotalHours = (val) => +val.monday_working_hours + +val.tuesday_working_hours + +val.wednesday_working_hours + +val.thursday_working_hours + +val.friday_working_hours + +val.saturday_working_hours + +val.sunday_working_hours                

                let grossAmount = allTimesheets.reduce((acc, val) => {
                  if (val.is_manual) {
                    return acc + +val.adjusted_amount
                  } else if (val.SoleTrader.WorkUnit === 'AREA') {
                    return acc + (+val.gross_amount + +val.manullay_deduction)
                  } else if (val.SoleTrader.WorkUnit === 'HOURS') {
                    return acc + (+val.current_daily_pay_rate * getTotalHours(val) + +val.manullay_deduction)
                  } else {
                    return acc + ((+val.current_daily_pay_rate / 9) * getTotalHours(val) + +val.manullay_deduction)
                  }
                }, 0);

                return (
                  <tr key={index}>
                    <td>
                      <img
                        className="table_icon"
                        src={icons?.timeSheet}
                        alt=""
                      />
                    </td>
                    <td>
                      {item?.last_date_of_pay_roll
                        ? dateFormateFullMonth(item?.last_date_of_pay_roll)
                        : "-"}
                    </td>
                    <td>
                      {dateFormate(item?.working_period_start)} -
                      {dateFormate(item?.working_period_end)}
                    </td>
                    <td>{item?.no_of_sole_traders}</td>
                    <td>{`£${(grossAmount / item.no_of_sole_traders).toFixed(2)}`}</td>
                    <td>£{grossAmount.toFixed(2)}</td>
                    <td
                      style={{
                        backgroundColor:
                          is_freezed
                            ? "#92D050"
                            : "#FFC001"
                      }}
                    >
                      {is_freezed ? timeSheetOtherStatus.COMPLETED : timeSheetOtherStatus.TO_BE_COMPLETED}
                    </td>

                    <td>
                      <button onClick={() =>
                        navigate(
                          `/timesheets/timesheet-detail`,
                          {
                            state: {
                              workPeriod: ` ${item.working_period_start} - ${item.working_period_end}`,
                              siteId: siteName && {
                                id: item.site_id,
                                name: siteName
                              },
                            },
                          }
                        )
                      }>View Timesheet</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </>
      )}
    </>
  );
};

export default TimeSheetTable;
